import {ChangeDetectorRef, Component, ViewChild,} from '@angular/core';
import {ConfirmationService, MessageService} from 'primeng/api';
import {TranslateService} from '@ngx-translate/core';
import {CrudBaseComponent} from "../../../crystal-elements/crud/crud-base.component";
import {CrudTableComponent} from "../../../crystal-elements/crud/crud-table.component";
import {CommonFieldService} from "../../../services/common/common-field.service";
import {SupportOrderService} from "../../../services/support/support-order/support-order.service";
import {
  SupportOrderTableConfigService
} from "../../../services/support/support-order/support-order-table-config.service";
import {
  SupportOrderFormConfigService
} from "../../../services/support/support-order/support-order-form-config.service";
import {FieldsService} from "../../../services/common/fields-service";
import {
  SupportOrderDataLoadingService
} from "../../../services/support/support-order/support-order-data-loading.service";
import {CCRoles} from "../../../model/security/cc-roles-type";
import {Account} from "../../../model/clearing/account";
import {Order} from "../../../model/clearing/order";
import {PrepareFormDateFields, PrepareForSaveDateFields} from "../../../utils/form-helper";
import {takeUntil, timer} from "rxjs";

@Component({
  selector: 'app-support-order-crud',
  templateUrl: './order-crud.component.html',
  providers: [
    MessageService,
    ConfirmationService,
    TranslateService,
  ],
})
export class OrderCrudComponent extends CrudBaseComponent<Order> {

  @ViewChild('crudTable')
  public crudTable: CrudTableComponent;

  batchUpdateDialogVisible: boolean = false;

  constructor(cdref: ChangeDetectorRef,
              commonFieldService: CommonFieldService,
              supportService: SupportOrderService,
              messageService: MessageService,
              confirmationService: ConfirmationService,
              translateService: TranslateService,
              private readonly tableConfigService: SupportOrderTableConfigService,
              private readonly formConfigService: SupportOrderFormConfigService,
              private readonly fieldsService: FieldsService,
              public dataLoadingService: SupportOrderDataLoadingService) {
    super(cdref, messageService, confirmationService, translateService, commonFieldService);
    this.crudService = supportService;
    this.newRecord = new Order();
    this.newRecord.account = new Account()
    this.writeRoles = CCRoles.ROLES_TOOLS_SUPPORT_TOC;
    this.transPartKey = 'support.order';
    this.fieldId = 'id';
  }

  ngOnDestroy() {
    super.ngOnDestroy();
  }

  protected initConfigs() {
    super.initConfigs();
    this.tableConfig = this.tableConfigService.loadConfig(this);
    this.formConfig = this.formConfigService.loadConfig(this)
    this.initButtons();
  }

  protected initButtons() {
    //remove add and clone
    this.headerButtonConfig.splice(0,1);
    this.headerButtonConfig.splice(1,1);
    this.contextMenuConfig.splice(1,1);
    //add batch update and refresh
    this.headerButtonConfig.splice(1, 0,
      {
        'tooltip': this.translateService.instant('common.table.batch_update_button'),
        'icon': 'fas fa-pen-to-square',
        class: ' p-button-help',
        command: records => this.batchUpdate(),
        enabled: () => this.hasMultipleSelection()
      }
    );
    this.headerButtonConfig.push(
      {
        separator: true
      },
      {
        'tooltip': this.translateService.instant('common.table.refresh_button'),
        'icon': 'fas fa-refresh',
        class: ' p-button-help',
        command: records =>this.reload(),
        enabled: () => true
      }
    );
    this.headerButtonConfig = [...this.headerButtonConfig];

    this.contextMenuConfig.splice(1, 0,
      {
        id: 'batch-update',
        label: this.translateService.instant('common.table.batch_update_button'),
        icon: 'fas fa-pen-to-square',
        command: () => {
          this.batchUpdate();
        }
      }
    );
    this.contextMenuConfig = [...this.contextMenuConfig];
  }

  onFormShow() {
  }

  protected initData(): void {
    super.initData();

    this.settingsFormLoadingProgressValue = 0;

    this.tracker = this.fieldsService.createTracker();

    this.tracker.progress.subscribe(value => {
      this.settingsFormLoadingProgressValue = value;
    });

    this.dataLoadingService.loadData(this);
  }

  public confirmDialog(
    action: () => void,
    titleKey: string,
    messageKey: string,
    submitKey = 'common.dialog.ok',
    cancelKey = 'common.dialog.cancel',
  ): void {
    this.confirmationService.confirm({
      header: this.getTranslation(titleKey),
      message:
        this.getTranslation(messageKey),
      icon: 'fas fa-exclamation-triangle',
      acceptLabel: this.getTranslation(submitKey),
      rejectLabel: this.getTranslation(cancelKey),
      acceptButtonStyleClass: 'p-button-danger p-button-sm',
      rejectButtonStyleClass: 'p-button-warning p-button-sm',
      accept: () => action(),
    });
  }

  private batchUpdate() {
    this.formRecord = undefined;
    if (this.selectedRecords && this.selectedRecords.length > 0) {
      this.formRecord = {...this.selectedRecords[0]};
    }
    this.prepareRecordForEdit();
    this.onFormShow();

    this.batchUpdateDialogVisible = true;
  }

  refreshContextMenu() {
    this.contextMenuConfig.forEach(menu => {
      if (menu.id === 'batch-update') {
        menu.disabled = !this.hasMultipleSelection()
      }
    });
    this.contextMenuConfig = [...this.contextMenuConfig];
  }

  public onSaved() {
    this.reload(2000)
  }

  public onBatchSaved() {
    this.selectedRecords.splice(0, this.selectedRecords.length);
    this.reload(2000)
  }

  private reload(timeout = 0) {
    timer(timeout)
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => this.crudTable.loadRecords());
  }

  prepareRecordForEdit(): void {
    PrepareFormDateFields(this.formRecord, this.formConfig);
  }

  prepareRecordForSave(): void {
    PrepareForSaveDateFields(this.formRecord, this.formConfig);
  }
}
